import { call, put, takeLatest } from 'redux-saga/effects'
import {reset} from 'redux-form'

import { updatePassword } from './index.reducer'
import Api from '../../services/ApiCaller'
import { showMessage, showErrorMessage } from '../../utils'
import { translate } from '../../i18n'

export function* updatePasswordRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(updatePassword.success(res))
      showMessage(`${translate('loginMessages.SuccessfulChangePassword')}`)
      yield put(reset('ChangePasswordForm'))
    } else {
      yield put(updatePassword.failure(message))
    }
  } catch (e) {
    yield put(updatePassword.failure(e.message))
  }
}

export default (api: any) => {
  const updatePasswordApi = (data: any) => {
    return api.put(`/users/password`, data)
  }
  return [
    takeLatest(updatePassword.TRIGGER, updatePasswordRequest, updatePasswordApi)
  ]
}
